import React from "react";
import { Typography } from "@mui/material";
import { Box } from "@mui/material";
import { formatStatusLabel } from "../../../utils/status";
interface StatusBadgeProps {
  variant: "active" | "pending" | "cancelled" | "completed" | "sent";
  label?: string;
}

export const StatusTag = ({ status }: { status: string }) => {
  return (
    <Typography
      sx={{
        textTransform: "capitalize",
        color:
          status === "Active" || status === "active" ? "#0E9F6E" : "#F05252",
        fontSize: "16px",
        fontWeight: "400",
      }}
    >
      {status || "-"}
    </Typography>
  );
};

export const LiveStatusTag = ({ status }: { status: string }) => {
  return (
    <Typography
      sx={{
        textTransform: "capitalize",
        color:
          status === "Live" || status === "live" || status === "Locked"
            ? "#0E9F6E"
            : "#F05252",
        fontSize: "16px",
        fontWeight: "400",
      }}
    >
      {status || "-"}
    </Typography>
  );
};
export const CompletedStatusTag = ({ status }: { status: string }) => {
  return (
    <Typography
      variant="body2"
      fontWeight="medium"
      sx={{
        textTransform: "capitalize",
        color:
          status === "Completed" || status === "completed"
            ? "#03543F"
            : "#9B1C1C",
        bgcolor:
          status === "Completed" || status === "completed"
            ? "#DEF7EC"
            : "#FDE8E8",
        display: "inline-block",
        borderRadius: "6px",
        p: "2px 8px",
        textAlign: "center",
      }}
    >
      {status || "-"}
    </Typography>
  );
};

export const CustomStatusChip = ({
  label,
  color,
  bgColor,
}: {
  label: string;
  color: string;
  bgColor: string;
}) => {
  return (
    <Typography
      variant="body2"
      fontWeight="medium"
      sx={{
        color: color || "text.primary",
        bgcolor: bgColor || "#F3F4F6",
        width: "fit-content",
        borderRadius: "6px",
        p: "2px 8px",
        textAlign: "center",
      }}
    >
      {label}
    </Typography>
  );
};

export const StatusBadge: React.FC<StatusBadgeProps> = ({ variant, label }) => {
  const badges = {
    active: { background: "#DCFCE7", color: "#166534", border: "#BBF7D0" },
    sent: {
      background: "#DBEAFE",
      color: "#1E3A8A",
      border: "#BFDBFE",
    },
    pending: { background: "#FEF3C7", color: "#92400E", border: "#FDE68A" },
    cancelled: { background: "#FEE2E2", color: "#991B1B", border: "#FECACA" },
    completed: { background: "#F3F4F6", color: "#1F2937", border: "#E5E7EB" },
  };
  const formattedLabel = formatStatusLabel(label);

  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        p: "2px 8px",
        borderRadius: "99px",
        border: `1px solid ${badges?.[variant || "completed"].border}`,
        backgroundColor: badges?.[variant || "completed"].background,
        color: badges?.[variant || "completed"].color,
      }}
    >
      <Typography variant="caption" fontWeight={500}>
        {formattedLabel ?? variant.charAt(0).toUpperCase() + variant.slice(1)}
      </Typography>
    </Box>
  );
};

export default StatusBadge;
